"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCachedKYCStatus = void 0;
var KYC_TTL = 3600 * 1000; // 1h
var KYC_SHORT_TTL = 10 * 60 * 1000; // 10m
function getCachedKYCStatus(account, getKYCStatus, cacheKeyBase) {
    return __awaiter(this, void 0, void 0, function () {
        var canCache, key, data, newData, expiresAt, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof window === 'undefined') {
                        return [2 /*return*/, undefined];
                    }
                    canCache = typeof window.localStorage !== 'undefined';
                    key = "".concat(account, "-kyc-").concat(cacheKeyBase);
                    if (canCache) {
                        data = void 0;
                        try {
                            data = JSON.parse(window.localStorage.getItem(key));
                        }
                        catch (e) {
                            console.warn('Failed to parse cached KYC');
                        }
                        if ((data === null || data === void 0 ? void 0 : data.status) === 'valid') {
                            return [2 /*return*/, data];
                        }
                        // Always skip cache if not valid
                        // if (data?.expiresAt && Date.now() < data?.expiresAt) {
                        //   return data;
                        // }
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getKYCStatus(account).then(function (_a) {
                            var status = _a.status, formUrl = _a.formUrl, country = _a.country, declineReasons = _a.declineReasons;
                            return ({
                                status: status,
                                formUrl: formUrl,
                                country: country,
                                declineReasons: declineReasons,
                            });
                        })];
                case 2:
                    newData = _a.sent();
                    if (canCache && (newData === null || newData === void 0 ? void 0 : newData.status)) {
                        expiresAt = Date.now() +
                            (['valid', 'nothing'].includes(newData.status)
                                ? KYC_TTL
                                : KYC_SHORT_TTL);
                        localStorage.setItem(key, JSON.stringify(__assign(__assign({}, newData), { status: newData.status || 'nothing', expiresAt: expiresAt })));
                    }
                    return [2 /*return*/, newData];
                case 3:
                    e_1 = _a.sent();
                    console.error('KYC fail', e_1);
                    return [2 /*return*/, undefined];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getCachedKYCStatus = getCachedKYCStatus;
